export default {
      id: "oc-res-custom-data-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-custom-data",
      toString: function () {
        return this.url;
      }
    }